import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Link,
  Typography,
} from '@mui/material';

export const ActionButton = styled(Button)`
  border-radius: 4px;
  box-shadow: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
`;

export const ActionButtonsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2em;
  width: 300px;
`;

export const BuyNowButtonsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
`;

export const CancelButton = styled(Button)`
  border-radius: 0;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
`;

export const CouponCodeText = styled(FormLabel)`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 1em;
  text-align: center;
  text-transform: none;
`;

export const DialogOptionsWrapper = styled(Box)`
  border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  padding: 2px;
  text-align: right;
`;

export const PricingSelectionContainer = styled(Box)`
  margin-top: 2em;
`;

export const PurchaseAgreementCheckBox = styled(FormControlLabel)`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const PurchaseAgreementText = styled('span')`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
`;

export const PurchaseDialog = styled(Dialog)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 2em;
  width: 600px;
`;

export const PurchaseDialogActions = styled(DialogActions)`
  display: flex;
  gap: 10px;
  padding: 1rem;
`;

export const PurchaseDialogHeader = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 24px;
`;

export const PurchaseDialogImage = styled('img')`
  height: 25px;
  margin: 0;
  padding: 0;
`;

export const PurchaseDialogInfoText = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  display: block;
  font-size: 12px;
  margin-bottom: 1rem;
  padding-left: 2px;
`;

export const PurchaseDialogLink = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const PurchaseDialogSubtitle = styled(Typography)`
  font-size: 14px;
  margin-bottom: 1rem;
`;

export const PurchaseDialogTitle = styled(DialogTitle)`
  font-size: 16px;
  font-weight: 600;
`;

export const PurchaseScreenSubtitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  margin-bottom: 1rem;
`;

export const PurchaseScreenTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const ReceiptContainer = styled(Box)`
  margin-bottom: 2em;
  max-width: 280px;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.6;
`;

export const ReceiptDivider = styled('div')`
  border-top: ${({ theme }) => `1px dashed ${theme.palette.text.primary}`};
  margin: 8px 0;
`;

export const ReceiptLine = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ReceiptAmount = styled('span')`
  text-align: right;
  min-width: 80px;
`;

export const ReceiptTotal = styled(Box)`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 15px;
`;

export const ScreenWrapper = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 2em;
  width: 450px;
`;
